import rootReducer from './rootReducer'
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'

const storage = {
	getItem: (key) => Promise.resolve(read(key)),
	setItem: (key, value) => Promise.resolve(localStorage.setItem(key, JSON.stringify(value))),
	removeItem: (key) => Promise.resolve(localStorage.removeItem(key)),
}

const read = key => {
	try {
		const stored = JSON.parse(localStorage.getItem(key));

		if (stored === null || typeof stored !== 'object') {
			return null;
		}

		return Object.fromEntries(Object.entries(stored).map(([slice, value]) => [
			slice,
			typeof value === 'string' ? unpack(value) : value,
		]));
	} catch {
		return null;
	}
}

const unpack = value => {
	try {
		return JSON.parse(value);
	} catch {
		return value;
	}
}

const middlewares = []

const persistConfig = {
	key: "auth",
	keyPrefix: '',
	storage,
	serialize: false,
	deserialize: false,
	whitelist: ['auth']
}

const store = configureStore({
	reducer: persistReducer(persistConfig, rootReducer()),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: import.meta.env.DEV,
})

store.asyncReducers = {}

export const persistor = persistStore(store)

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false
	}
	store.asyncReducers[key] = reducer
	store.replaceReducer(persistReducer(persistConfig, rootReducer(store.asyncReducers)))
	persistor.persist()
	return store
}

export default store
